// import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { combineEpics, createEpicMiddleware } from "redux-observable";
import thunk from "redux-thunk";
import { authEpic } from "./auth/epic";
import { authReducer } from "./auth/reducer";
import { bannerReducer } from "./banner/reducer";
import { billngEpic } from "./billing/epic";
import { billingReducer } from "./billing/reducer";
import { cartEpic } from "./cart/epic";
import { cartReducer } from "./cart/reducer";
import { chainEpic } from "./chain/epic";
import { chainReducer } from "./chain/reducer";
import { cookiePolicyEpic } from "./cookie-policy/epic";
import { cookiePolicyReducer } from "./cookie-policy/reducer";
import { cryptoEpic } from "./crypto/epic";
import { cryptoReducer } from "./crypto/reducer";
import { errorEpic } from "./errors/epic";
import { errorReducer } from "./errors/reducer";
import { launchConfigurationsEpic } from "./launch-configurations/epic";
import { launchConfigurationsReducer } from "./launch-configurations/reducer";
import { launchesEpic } from "./launches/epic";
import { launchesReducer } from "./launches/reducer";
import { loaderReducer } from "./loader/reducer";
import { notificationEpic } from "./notifications/epic";
import { notificationReducer } from "./notifications/reducer";
import { sidebarReducer } from "./sidebar/reducer";
import { stakingEpic } from "./staking/epic";
import { stakingReducer } from "./staking/reducer";
import { usersEpic } from "./users/epic";
import { usersReducer } from "./users/reducer";
import { vaultsEpic } from "./vaults/epic";
import { vaultsReducer } from "./vaults/reducer";
import { verificationEpic } from "./verification/epic";
import { verificationReducer } from "./verification/reducer";
import { walletsEpic } from "./wallets/epic";
import { walletsReducer } from "./wallets/reducer";
import { emptySplitApi } from "./models/emptySplitApi";
import { configureStore, combineReducers } from "@reduxjs/toolkit";

const epicMiddleware = createEpicMiddleware();

const allReducers = combineReducers({
  auth: authReducer,
  users: usersReducer,
  verification: verificationReducer,
  notification: notificationReducer,
  vaults: vaultsReducer,
  error: errorReducer,
  loader: loaderReducer,
  wallets: walletsReducer,
  crypto: cryptoReducer,
  chain: chainReducer,
  launches: launchesReducer,
  sidebar: sidebarReducer,
  cookiePolicy: cookiePolicyReducer,
  banner: bannerReducer,
  launchConfigurations: launchConfigurationsReducer,
  cart: cartReducer,
  billing: billingReducer,
  staking: stakingReducer,
  [emptySplitApi.reducerPath]: emptySplitApi.reducer
});

const allEpics = combineEpics(
  authEpic,
  usersEpic,
  verificationEpic,
  notificationEpic,
  vaultsEpic,
  errorEpic,
  walletsEpic,
  cryptoEpic,
  chainEpic,
  launchesEpic,
  cookiePolicyEpic,
  launchConfigurationsEpic,
  cartEpic,
  billngEpic,
  stakingEpic
);

// const composeEnhancers =
//   (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// export const store = createStore(
//   allReducers,
//   composeEnhancers(applyMiddleware(epicMiddleware), applyMiddleware(thunk))
// );

export const store = configureStore({
  reducer: allReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(emptySplitApi.middleware)
      .concat(epicMiddleware)
      .concat(thunk)
})

export type AppStore = ReturnType<typeof allReducers>;
epicMiddleware.run(allEpics);

export type RootState = ReturnType<typeof store.getState>;